<div class="banner">
  <h1 class="visually-hidden">NITTO Tire Thailand | ยางสมรรถนะสูง สปอร์ต ทนทาน</h1>
  <web-promo-shared-pattern-lib-banner-carousel [data]="bannerObject()"></web-promo-shared-pattern-lib-banner-carousel>
</div>

<section class="container container-search">
  <web-promo-shared-pattern-lib-search-block
    class="themeSearchFormFieldAbsolute1"
    [visibility]="visibilitySignal()"
    [category]="categoryIdSignal()"
    [isTire]="true"
    [pageTire]="false"
    [typeFilter]="null"
    [hlightsFilter]="null"
    [optionDataSearch]="null"
    (OnSearch)="handleSearchSize($event)"
  ></web-promo-shared-pattern-lib-search-block>
  <web-promo-shared-pattern-lib-search-block
    class="themeSearchFormFieldAbsolute2"
    [visibility]="visibilitySignal()"
    [category]="categoryIdSignal()"
    [isTire]="true"
    [pageTire]="false"
    [typeFilter]="null"
    [hlightsFilter]="null"
    [optionDataSearch]="null"
    (OnSearch)="handleSearchSize($event)"
  ></web-promo-shared-pattern-lib-search-block>
</section>

@if (promotionListSignal()?.total_rows && promotionListSignal()) {
<section class="container pb-13">
  <h2 class="title title-black">โปรโมชั่น</h2>
  <div class="container-promotion">
    @for (item of promotionRows; track index; let index = $index) {
    <div class="{{ index < 1 ? 'item-mainItem' : 'item-subItem' }}">
      <lib-web-shared-ui-promotion-card
        class="themePromotion2"
        headingLevel="h3"
        [data]="{
            img: item.cover_image_url,
            title: item.title,
            excerpt: item.excerpt,
            id: item.id,
          }"
      ></lib-web-shared-ui-promotion-card>
    </div>
    }
  </div>
  <div class="container-button">
    <button mat-flat-button class="themeMoreButton1" (click)="routeToList('promotions')">เพิ่มเติม</button>
    <button mat-flat-button class="themeMoreButton2" (click)="routeToList('promotions')">เพิ่มเติม</button>
    <!-- <button mat-flat-button class="themeMoreButton1" (click)="onClickLoadMore(+promotionList.cur_page)"
        [disabled]="disableLoadMoreSignal()">
        เพิ่มเติม
      </button>
      <button mat-flat-button class="themeMoreButton2" (click)="onClickLoadMore(+promotionList.cur_page)"
        [disabled]="disableLoadMoreSignal()">
        เพิ่มเติม
      </button> -->
  </div>
</section>
} @if (galleryListSignal(); as galleryList) {
<section class="container pb-13">
  <h2 class="title title-black">แกลเลอรี่</h2>
  <section class="container-news">
    @for (item of galleryList.rows; track index; let index = $index) {
    <lib-web-shared-ui-gallery-card
      [data]="convertGalleryData(item)"
      [pathName]="ROUTER_TOKENS.GALLERY"
      headingLevel="h3"
    ></lib-web-shared-ui-gallery-card>
    }
  </section>
  <div class="container-button">
    <button mat-flat-button class="themeMoreButton1" (click)="routeToList('gallery')">เพิ่มเติม</button>
    <button mat-flat-button class="themeMoreButton2" (click)="routeToList('gallery')">เพิ่มเติม</button>
  </div>
</section>
} @if (articleListSignal()?.total_rows && articleListSignal(); as articleList) {
<section class="container pb-13">
  <h2 class="title title-black">บทความ</h2>
  <section class="container-news">
    @for (item of articleList.rows; track index; let index = $index) {
    <lib-web-shared-ui-news-card
      [data]="convertNewsData(item)"
      [pathName]="ROUTER_TOKENS.ARTICLE"
      headingLevel="h3"
    ></lib-web-shared-ui-news-card>
    }
  </section>
  <div class="container-button">
    <button mat-flat-button class="themeMoreButton1" (click)="routeToList('article')">เพิ่มเติม</button>
    <button mat-flat-button class="themeMoreButton2" (click)="routeToList('article')">เพิ่มเติม</button>
  </div>
</section>
} @if (videoListSignal()?.total_rows && videoListSignal(); as videoList) {
<section class="layout-video">
  <h2 class="title title-black">วีดิโอความรู้</h2>
  <div class="container pb-13">
    <div class="container-video">
      @for (item of videoList.rows; track index; let index = $index) {
      <lib-web-shared-ui-knowledge-card
        class="themeKnowledge1"
        headingLevel="h3"
        [data]="convertVideoData(item)"
        (emitVideoLinkUrl)="openPopupYoutube($event)"
      ></lib-web-shared-ui-knowledge-card>
      }
    </div>
    <div class="container-button">
      <button mat-flat-button class="themeMoreButton1" (click)="routeToList('video')">เพิ่มเติม</button>
      <button mat-flat-button class="themeMoreButton2" (click)="routeToList('video')">เพิ่มเติม</button>
    </div>
  </div>
</section>
} @if (newsListSignal()?.total_rows && newsListSignal(); as newsList) {
<section class="container pb-13">
  <h2 class="title title-black">ข่าวสาร</h2>
  <section class="container-news">
    @for (item of newsList.rows; track index; let index = $index) {
    <lib-web-shared-ui-news-card [data]="convertNewsData(item)" headingLevel="h3"></lib-web-shared-ui-news-card>
    }
  </section>
  <div class="container-button">
    <button mat-flat-button class="themeMoreButton1" (click)="routeToList('news')">เพิ่มเติม</button>
    <button mat-flat-button class="themeMoreButton2" (click)="routeToList('news')">เพิ่มเติม</button>
  </div>
</section>
}

<!-- {{ promotionListSignal() | json }} -->
<!-- {{ newsListSignal() | json }} -->
<!-- {{ videoListSignal() | json }} -->
